export default __webpack_public_path__ + "static/media/slider-madrid-3.9d06b7d1.jpg";